'use client';

import { usePathname } from 'next/navigation';

import { DEFAULT_LOCALE, LOCALES } from '../constants/common';
import { Locale } from '../types';
import { getClientHost, getLocaleByDomain } from '../utils/getDomainInfo';

const FALLBACK_LOCALE: Locale = 'ru';

/**
 * Получает локаль из первого сегмента pathname.
 */
export const getLocaleFromPathname = (pathname: string | null): Locale => {
  /** Посмотрим на локаль из адресной строки */
  const locale = pathname?.split('/').filter(Boolean)[0];
  /** Хост понадобится для опеределени дефолтной локали конкретного домена */
  const host = getClientHost();

  if (Object.values(LOCALES).includes(locale as LOCALES)) {
    return locale as Locale;
  }

  /** Случай в котором мы находимся на дефолтной локали хоста прим. .kz/business */
  if (!Object.values(LOCALES).includes(locale as LOCALES) && getClientHost()) {
    return getLocaleByDomain(host);
  }

  if (Object.values(LOCALES).includes(DEFAULT_LOCALE as LOCALES)) {
    return DEFAULT_LOCALE as Locale;
  }

  return FALLBACK_LOCALE;
};

/**
 * Получает текущую локаль из pathname на клиенте.
 */
export const useCurrentLocale = (): Locale => {
  const pathname = usePathname();

  return getLocaleFromPathname(pathname);
};
